import React, {useContext, useEffect} from 'react'
import {Form, InputNumber} from "antd";
import {OfferContext} from "../../../context/OfferContext";

const OfferCreateDiscount2 = ({rowIndex, record}) => {

    const [form] = Form.useForm()
    const {materialInformation} = useContext(OfferContext)
    const [materials, setMaterials] = materialInformation

    useEffect(() => {
        form.setFieldsValue({
            [`${rowIndex}-lineDiscount2`]: (record.data && record.data.discount2) || 0
        })
    }, [rowIndex, record])

    const handleDiscountChange = ({target}) => {
        let mockContext = [...materials]
        mockContext[rowIndex].data.discount2 = target.value
        setMaterials(mockContext)
    }

    return (
        <React.Fragment>
            <Form
                form={form}
            >
                <Form.Item
                    name={`${rowIndex}-lineDiscount2`}
                >
                    <InputNumber
                        disabled={!record.data || !record.data.discount > 0}
                        onBlur={handleDiscountChange}
                        min={0}
                        max={100}
                        step={0.1}
                    />
                </Form.Item>
            </Form>
        </React.Fragment>
    )
}
export default OfferCreateDiscount2